import { TargetedCampaign } from "./TargetedCampaign/TargetedCampaign";
import { View } from "@aws-amplify/ui-react";

export function NewTargetedCampaign(props) {
    return (
        <View>
            <TargetedCampaign {...props} />
        </View>
    );
}
